import React, { useEffect, useState } from "react";
import "../../../tool-js/ls-productivity-tools.d.ts";
import "../../../tool-js/ls-productivity-tools.js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getSoeTemplateJson } from "./soeService";
import { CircularProgress } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { useSelector } from "react-redux";
import { PHONEME_DATA_LIST } from "./FeatureCourse/constants";

interface ActivityPlayerElement extends Element {
  // Add properties and methods specific to ls-productivity-tools if needed
  definition?: any; // Adjust the type according to your actual definition type
  action?: string;
}
const SoeTemplate = () => {
  const { templateTitle } = useSelector((state: any) => state.soundsOfEnglish);
  const navigate = useNavigate();
  const { activityId, template, templateID } = useParams();
  const { state } = useLocation();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    loadActivityPlayer();
  }, [templateID]);

  const loadActivityPlayer = async () => {
    try {
      let activityPlayerElement = document.querySelector("ls-productivity-tools") as ActivityPlayerElement;

      if (template) {
        const classId = Number(state?.submenu?.classid);
        const SelectedActivityId = Number(state?.submenu?.id);
        const valueId = Number(state?.submenu?.vValue);
        const title = templateTitle;
        const templateType = state?.name;
        setLoading(true);
        const finalDynamicJson = await getSoeTemplateJson(classId, SelectedActivityId, valueId, title, templateType);
        const parsedJson = finalDynamicJson ? JSON.parse(finalDynamicJson) : {};
        activityPlayerElement.definition = parsedJson;
        setLoading(false);
      } else {
        const classId = Number(activityId);
        const vValue = PHONEME_DATA_LIST.find((item: any) => item.Id == activityId)?.vValue;
        const finalDynamicJson = await getSoeTemplateJson(classId, 0, Number(vValue), templateTitle, "default");
        const parsedJson = finalDynamicJson ? JSON.parse(finalDynamicJson) : {};
        activityPlayerElement.definition = parsedJson;
        setLoading(false);
      }
      activityPlayerElement.action = "load";
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };
  return (
    <>
      {loading && (
        <div className="LoaderContainer">
          <div className="loader_img">
            <CircularProgress className="loader" size={35} style={{ color: "primary" }} />
          </div>
        </div>
      )}
      <button
        className="soe-back-button display-flex pointer"
        data-testid={`soe-back-button`}
        onClick={() => navigate("/soundsofenglish")}
      >
        {" "}
        <ArrowBackIosIcon />
        <span className="back-button">Back</span>
      </button>
      <div data-testid={`ls-productivity`}>
        <ls-productivity-tools />
      </div>
    </>
  );
};

export default SoeTemplate;
